<div>
  <ng-content select="td-wb-card-title, td-wb-card-subtitle" />
</div>
<ng-content />
